<script setup lang="ts">
import type { PageThumbFragment } from '#graphql-operations'

interface SearchTreatmentProps {
  data: PageThumbFragment
}

defineProps<SearchTreatmentProps>()
</script>

<template>
  <ButtonLink :link="data" :title="data.title" />
</template>
